import { useSelector } from 'react-redux';
import React from 'react';
import { useField, useFormState } from 'react-final-form';

import FeatureWrapper from '../../../ai-features/feature-wrapper/FeatureWrapper';
import AIAssistantsContainer from '../../../ai-features/ai-assistants-container/AIAssistantsContainer';
import arraysHaveSameElements from '../../../../utils/arraysHaveSameElements';

function AIAssistantsFromInner({ onSubmit }) {
  const { submitting } = useFormState();

  const assistantsFields = useField('assignedAssistants');
  const companyAssistants = useSelector((state) => state.customers.customerInfo?.assistants);

  const isSaveDisabled = arraysHaveSameElements(
    assistantsFields.input.value.map(({ id }) => id),
    companyAssistants.map(({ id }) => id),
  );

  return (
    <FeatureWrapper title='AI Assistants' onSave={onSubmit} isSaving={submitting} isSaveDisabled={isSaveDisabled}>
      {({ search, disabled }) => (
        <AIAssistantsContainer search={search} disabled={disabled} fieldName='assignedAssistants' />
      )}
    </FeatureWrapper>
  );
}

export default AIAssistantsFromInner;
